import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "@/components/Nav";
import api from "@/lib/api";
import { Trophy, Award } from "lucide-react";
import { formatScore, scoreLabel } from "@/lib/scoreFormat";

export default function History() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/tournaments/history");
        setItems(r.data);
      } finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-slate-950">
      <Nav />
      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-10">
        <div className="text-xs text-slate-500 font-mono-data tracking-widest">HISTORY</div>
        <h1 className="text-4xl md:text-5xl font-bold mt-2 text-slate-50 flex items-center gap-3"><Trophy className="w-9 h-9 text-amber-400" /> Your finishes</h1>
        <p className="text-slate-400 mt-2">Every past tournament you've played in and where you ranked.</p>

        {loading ? (
          <div className="mt-8 text-slate-500">Loading…</div>
        ) : items.length === 0 ? (
          <div className="mt-10 rounded-2xl border border-dashed border-white/10 p-12 text-center">
            <p className="text-slate-400">No finished tournaments yet.</p>
          </div>
        ) : (
          <div className="mt-8 space-y-3">
            {items.map(t => {
              const rankColor = t.rank === 1 ? "text-amber-400" : t.rank === 2 ? "text-slate-300" : t.rank === 3 ? "text-orange-500" : "text-slate-500";
              return (
                <Link to={`/tournament/${t.tournament_id}`} key={t.tournament_id} data-testid={`history-${t.tournament_id}`} className="block rounded-xl border border-white/10 bg-slate-900/50 p-6 hover:border-amber-500/30 transition-colors">
                  <div className="flex items-center justify-between flex-wrap gap-4">
                    <div>
                      <div className="text-slate-100 text-xl">{t.name}</div>
                      {t.game_name && <div className="text-xs text-slate-500 font-mono-data uppercase tracking-wider mt-1">{t.game_name}</div>}
                      <div className="text-xs text-slate-500 mt-1">{t.total_participants} players · {t.finished_at ? new Date(t.finished_at).toLocaleDateString() : ""}</div>
                    </div>
                    <div className="flex items-center gap-8">
                      <div className="text-right">
                        <div className="text-xs text-slate-500 font-mono-data tracking-widest">{scoreLabel(t.tournament_type)}</div>
                        <div className="font-mono-data text-slate-100 text-lg">{formatScore(t.total_score || 0, t.tournament_type)}</div>
                      </div>
                      <div className="text-right">
                        <div className="text-xs text-slate-500 font-mono-data tracking-widest">RANK</div>
                        <div className={`font-mono-data text-4xl ${rankColor} flex items-center gap-2`}>
                          {t.rank && t.rank <= 3 && <Award className="w-6 h-6" />}
                          #{t.rank || "—"}
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
